import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

// images
import heroBg from "../images/13.jpeg";
import about from "../images/17.jpg";

import milk from "../images/milk.jpg";
import freshPaneer from "../images/1.jpg";
import pureGhee from "../images/5.jpg";
import greekYogurt from "../images/9.jpeg";

const Home = () => {
  const [animateStats, setAnimateStats] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimateStats(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const stats = [
    { number: "65+", label: "SHG Members" },
    { number: "500+", label: "Liters/Day" },
    { number: "5+", label: "Villages" },
    { number: "8+", label: "Products" },
  ];

  const products = [
    { name: "Fresh Milk", desc: "Pure cow & buffalo milk", img: milk },
    { name: "Paneer", desc: "Fresh homemade paneer", img: freshPaneer },
    { name: "Ghee", desc: "Traditional pure ghee", img: pureGhee },
    { name: "Yogurt", desc: "Creamy fresh yogurt", img: greekYogurt },
  ];

  return (
    <div className="fade-in">
      {/* Hero Section */}
      <section
        className="hero-bg text-white text-center py-5"
        style={{ minHeight: "80vh", display: "flex", alignItems: "center" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto slide-up">
              <h1 className="display-3 fw-bold mb-4">
                Women SHG Enterprises (WiSE)
              </h1>
              <p className="lead fs-4 mb-5">
                Empowering rural women through entrepreneurship and sustainable
                livelihoods
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <Button
                  as={Link}
                  to="/about"
                  size="lg"
                  className="btn-primary-custom px-4"
                >
                  Learn More
                </Button>
                <Button
                  as={Link}
                  to="/products"
                  variant="outline-light"
                  size="lg"
                  className="px-4"
                >
                  Explore Products
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Stats Section */}
      <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Container>
          <Row>
            {stats.map((stat, index) => (
              <Col md={3} key={index} className="text-center mb-4">
                <div
                  className={`stats-counter ${animateStats ? "bounce" : ""}`}
                >
                  {stat.number}
                </div>
                <p className="fs-5 text-muted">{stat.label}</p>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* About Preview */}
      <section className="section-padding">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="slide-up">
              <h2
                className="fw-bold mb-4"
                style={{ color: "#2E8B57", fontSize: "1.2rem" }}
              >
                Women SHG Enterprises (WiSE)
              </h2>
              <p className="fs-5 text-muted mb-4">
                WiSE is dedicated to empowering rural women through dairy
                entrepreneurship, Agri entrepreneurship, Food Products providing
                fair pricing, quality products, and sustainable livelihoods for
                Self Help Groups.
              </p>
              <ul className="list-unstyled fs-6">
                <li className="mb-2">
                  ✅ Fair pricing with IoT milk analyzer technology
                </li>
                <li className="mb-2">
                  ✅ Training and capacity building programs
                </li>
                <li className="mb-2">
                  ✅ Quality assurance and buy-back guarantee
                </li>
                <li className="mb-2">
                  ✅ Market linkages and enterprise development
                </li>
              </ul>
              <Button as={Link} to="/about" className="btn-primary-custom mt-3">
                Read Our Full Story
              </Button>
            </Col>
            <Col lg={6}>
              <img
                src={about}
                alt="Women empowerment"
                className="img-fluid rounded shadow-lg hover-lift"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Vision & Mission */}
      <section
        className="section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <Container>
          <Row>
            <Col lg={6} className="mb-5">
              <div className="bg-white p-5 rounded shadow-lg h-100">
                <div className="text-center mb-4">
                  <div className="service-icon">👁️</div>
                </div>
                <h3 className="text-center fw-bold mb-4 text-gradient">
                  Our Vision
                </h3>
                <p className="fs-6 text-muted text-center">
                  Women SHG Enterprises is a startup envisaged to act as
                  resource center where all necessary support is made available
                  from a single platform for providing Training, Capacity
                  Building in various technologies providing livelihood and
                  other Business opportunities and improving the quality of life
                  of the women by reducing their drudgery, Better Resource
                  management through value addition etc.
                </p>
              </div>
            </Col>
            <Col lg={6} className="mb-5">
              <div className="bg-white p-5 rounded shadow-lg h-100">
                <div className="text-center mb-4">
                  <div className="service-icon">🎯</div>
                </div>
                <h3 className="text-center fw-bold mb-4 text-gradient">
                  Our Mission
                </h3>
                <p className="fs-6 text-muted text-center">
                  To provide comprehensive support to women entrepreneurs
                  through training, technology integration, market linkages, and
                  quality assurance, while promoting sustainable practices and
                  community development.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Featured Products */}
      <section className="section-padding">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Available Now</h2>
              <p className="fs-5 text-muted">
                High-quality dairy products made with care and tradition
              </p>
            </Col>
          </Row>
          <Row>
            {products.map((product, index) => (
              <Col md={6} lg={3} key={index} className="mb-4">
                <Card className="card-hover h-100 border-0">
                  <Card.Img
                    variant="top"
                    src={product.img}
                    className="product-image"
                  />
                  <Card.Body className="text-center">
                    <Card.Title className="fw-bold">{product.name}</Card.Title>
                    <Card.Text className="text-muted">{product.desc}</Card.Text>
                    <Button variant="outline-primary" size="sm">
                      Learn More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-4">
            <Button as={Link} to="/products" className="btn-primary-custom">
              View All Products
            </Button>
          </div>
        </Container>
      </section>

      {/* Services Preview */}
      <section
        className="section-padding"
        style={{ backgroundColor: "#f8f9fa" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center mb-5">
              <h2 className="display-5 fw-bold mb-3">Our Services</h2>
              <p className="fs-5 text-muted">
                Comprehensive support for women and Agri Farmer entrepreneurs
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="text-center mb-4">
              <div className="service-icon">🎓</div>
              <h4>Training Programs</h4>
              <p className="text-muted">
                Capacity building and skill development
              </p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <div className="service-icon">🔬</div>
              <h4>IoT Technology</h4>
              <p className="text-muted">
                Dairy, Agri, Food Products Processing, etc., and quality testing
              </p>
            </Col>
            <Col md={4} className="text-center mb-4">
              <div className="service-icon">🤝</div>
              <h4>Market Linkage</h4>
              <p className="text-muted">
                Direct market access and buy-back support
              </p>
            </Col>
          </Row>
          <div className="text-center">
            <Button as={Link} to="/services" className="btn-primary-custom">
              Explore All Services
            </Button>
          </div>
        </Container>
      </section>

      {/* CTA Section */}
      <section
        className="py-5 text-white"
        style={{ background: "linear-gradient(135deg, #2E8B57, #4682B4)" }}
      >
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="display-5 fw-bold mb-3">Ready to Join WiSE?</h2>
              <p className="fs-5 mb-4">
                Be part of the women empowerment movement in dairy
                entrepreneurship
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <Button
                  as={Link}
                  to="/contact"
                  variant="light"
                  size="lg"
                  className="px-4"
                >
                  Contact Us
                </Button>
                <Button
                  as={Link}
                  to="/signup"
                  variant="outline-light"
                  size="lg"
                  className="px-4"
                >
                  Join Now
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Home;
